import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Azienda from "@/components/Azienda";
import Lavorazioni from "@/components/Lavorazioni";
import Attrezzature from "@/components/Attrezzature";
import GalleriaPreview from "@/components/GalleriaPreview";
import Perche from "@/components/Perche";
import Processo from "@/components/Processo";
import CtaBanner from "@/components/CtaBanner";
import Contatti from "@/components/Contatti";
import Footer from "@/components/Footer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Galleria from "@/pages/Galleria";
import Admin from "@/pages/Admin";

const HomePage = () => (
    <main>
        <Hero />
        <Marquee />
        <Azienda />
        <Lavorazioni />
        <Attrezzature />
        <GalleriaPreview />
        <Perche />
        <Processo />
        <CtaBanner />
        <Contatti />
    </main>
);

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        window.__lenis = lenis;
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <ScrollManager />
                <Header />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/cookie-policy" element={<CookiePolicy />} />
                    <Route path="/galleria" element={<Galleria />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
                <Footer />
                <Toaster
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "#171A1E",
                            border: "1px solid rgba(201,162,84,0.4)",
                            color: "#F4F5F7",
                            borderRadius: 0,
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
